export default __webpack_public_path__ + "static/media/case_banner.916b4f9c.png";